package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings

private const val KEY_PLAYER_NAME = "player_name"
private const val KEY_NAME_PROMPT_DONE = "player_name_prompt_done"
private const val KEY_INSTALL_ID = "install_id"
private const val KEY_SESSION_COUNT = "session_count"
private const val INSTALL_ID_ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789"

class SettingsProfileStore(
    private val settings: Settings,
) : ProfileStore {
    override fun playerName(): String = settings.getStringOrNull(KEY_PLAYER_NAME).orEmpty()

    override fun setPlayerName(name: String) {
        settings.putString(KEY_PLAYER_NAME, name)
    }

    override fun namePromptDone(): Boolean = settings.getBoolean(KEY_NAME_PROMPT_DONE, false)

    override fun setNamePromptDone() {
        settings.putBoolean(KEY_NAME_PROMPT_DONE, true)
    }

    override fun installId(): String {
        val existing = settings.getStringOrNull(KEY_INSTALL_ID)
        if (!existing.isNullOrBlank()) return existing
        val created = buildString(8) {
            repeat(8) { append(INSTALL_ID_ALPHABET[kotlin.random.Random.nextInt(INSTALL_ID_ALPHABET.length)]) }
        }
        settings.putString(KEY_INSTALL_ID, created)
        return created
    }

    override fun incrementAndGetSessionCount(): Int {
        val next = settings.getInt(KEY_SESSION_COUNT, 0) + 1
        settings.putInt(KEY_SESSION_COUNT, next)
        return next
    }

    override fun sessionCount(): Int = settings.getInt(KEY_SESSION_COUNT, 0)
}
